import { render, staticRenderFns } from "./AgentSpecial.vue?vue&type=template&id=b160e4f2"
import script from "./AgentSpecial.vue?vue&type=script&lang=js"
export * from "./AgentSpecial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports